import React from 'react';
import PropTypes from 'prop-types';

class ExternalRedirect extends React.Component {
  componentDidMount() {
    const { loc } = this.props;
    if (window.opener) {
      const { callback } = window.opener.authData;
      callback(true);
      window.close();
    } else {
      window.location = loc;
    }
  }

  render() {
    return (<section>Validating...</section>);
  }
}

ExternalRedirect.propTypes = {
  loc: PropTypes.string.isRequired
};

export default ExternalRedirect;